// src/components/MiniBars.jsx
//
// Лёгкий SVG-барчарт без зависимостей.
// data: [{ label, value, value2? }]  — value = основная (выручка),
//        value2 (необяз.) рисуется тёмным сегментом снизу (прибыль).
// Адаптивная ширина через viewBox + preserveAspectRatio.

export default function MiniBars({
  data = [],
  height = 140,
  color = 'var(--brand-primary)',
  color2 = 'var(--brand-primary-strong, #4f46e5)',
  formatValue,
  showEvery,         // подпись оси X через каждые N столбцов
}) {
  if (!data.length) return null;

  const W = 320;
  const H = height;
  const padB = 18;   // место под подписи X
  const padT = 6;
  const innerH = H - padB - padT;
  const max = Math.max(1, ...data.map(d => d.value || 0));
  const n = data.length;
  const gap = n > 24 ? 1 : 3;
  const bw = (W - gap * (n - 1)) / n;
  const step = showEvery || (n <= 10 ? 1 : n <= 20 ? 3 : Math.ceil(n / 8));

  const barH = (v) => Math.max(0, (v / max) * innerH);

  return (
    <svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none"
         style={{ width: '100%', height: H, display: 'block', overflow: 'visible' }}>
      {data.map((d, i) => {
        const x = i * (bw + gap);
        const hMain = barH(d.value || 0);
        const hProfit = d.value2 != null ? barH(d.value2) : 0;
        const yMain = padT + innerH - hMain;
        const yProfit = padT + innerH - hProfit;
        return (
          <g key={i}>
            <rect x={x} y={yMain} width={bw} height={hMain} rx={Math.min(2, bw / 3)} fill={color} opacity={0.35} />
            {d.value2 != null && (
              <rect x={x} y={yProfit} width={bw} height={hProfit} rx={Math.min(2, bw / 3)} fill={color2} opacity={0.9} />
            )}
            {i % step === 0 && (
              <text x={x + bw / 2} y={H - 5} textAnchor="middle"
                    fontSize="8" fill="var(--fg-faint)" style={{ fontVariantNumeric: 'tabular-nums' }}>
                {d.label}
              </text>
            )}
          </g>
        );
      })}
    </svg>
  );
}
